// SSO Service for handling Single Sign-On authentication
// This integrates with Google OAuth and can be extended for other providers

class SSOService {
  constructor() {
    this.googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '1057220697534-06dlu7ljbjdk3b4e8n85nfmslianp753.apps.googleusercontent';
  }

  /**
   * Initialize Google Sign-In
   * In production, you would use Google Identity Services (new) or gapi-script
   */
  async initializeGoogle() {
    // Check if Google API is already loaded
    if (window.google && window.google.accounts) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      // Load Google Identity Services script
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        if (window.google && window.google.accounts) {
          resolve();
        } else {
          reject(new Error('Google Identity Services failed to load'));
        }
      };
      script.onerror = () => reject(new Error('Failed to load Google Identity Services'));
      document.head.appendChild(script);
    });
  }

  /**
   * Sign in with Google using Google Identity Services
   */
  async signInWithGoogle() {
    try {
      await this.initializeGoogle();

      return new Promise((resolve, reject) => {
        const client = window.google.accounts.oauth2.initTokenClient({
          client_id: this.googleClientId,
          scope: [
            'https://www.googleapis.com/auth/calendar',
            'https://www.googleapis.com/auth/contacts.readonly',
            'https://www.googleapis.com/auth/gmail.readonly',
            'https://www.googleapis.com/auth/gmail.modify',
            'https://www.googleapis.com/auth/gmail.send',
            'https://www.googleapis.com/auth/gmail.settings.basic',
            'https://www.googleapis.com/auth/gmail.settings.sharing',
            "https://www.googleapis.com/auth/spreadsheets.readonly",
            "https://www.googleapis.com/auth/documents.readonly",
            "https://www.googleapis.com/auth/drive.readonly",
            'email',
            'profile',
            'openid'
          ].join(' '),
          callback: (tokenResponse) => {
            if (tokenResponse.access_token) {
              // Fetch user info using the access token
              fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                headers: {
                  Authorization: `Bearer ${tokenResponse.access_token}`,
                },
              })
                .then((res) => res.json())
                .then((userData) => {
                  // debugger;
                  // Store authentication data in localStorage
                  localStorage.setItem('authToken', tokenResponse.access_token);
                  localStorage.setItem('userEmail', userData.email);
                  localStorage.setItem('userName', userData.name);
                  localStorage.setItem('userPicture', userData.picture);
                  localStorage.setItem('authMethod', 'google');
                  localStorage.setItem('userId', userData.sub);
                  localStorage.setItem('loginTimestamp', new Date().toISOString());
                  
                  // Resolve with user data
                  resolve({
                    ...userData,
                    token: tokenResponse.access_token
                  });
                })
                .catch((err) => {
                  console.error('Error fetching user info:', err);
                  reject(new Error('Failed to fetch user info'));
                });
            } else {
              reject(new Error('Failed to get access token'));
            }
          },
        });

        // Request the token
        client.requestAccessToken();
      });
    } catch (error) {
      throw new Error(`Google SSO failed: ${error.message}`);
    }
  }

  /**
   * Sign out from Google
   */
  async signOutFromGoogle() {
    try {
      if (window.google && window.google.accounts) {
        window.google.accounts.id.disableAutoSelect();
      }
      // debugger
      // Clear local storage
      localStorage.removeItem('authToken');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('userName');
      localStorage.removeItem('userPicture');
      localStorage.removeItem('authMethod');
      localStorage.removeItem('userId');
      localStorage.removeItem('loginTimestamp');
      localStorage.removeItem('evaSessionId'); // Clear session ID on sign out
      localStorage.removeItem('evaSessionTimestamp'); // Clear session timestamp on sign out
      
      return true;
    } catch (error) {
      console.error('Error signing out from Google:', error);
      return false;
    }
  }

  /**
   * Check if user is authenticated
   */
  isAuthenticated() {
    return !!localStorage.getItem('authToken');
  }

  /**
   * Get current user data
   */
  getCurrentUser() {
    if (!this.isAuthenticated()) {
      return null;
    }

    return {
      email: localStorage.getItem('userEmail'),
      name: localStorage.getItem('userName'),
      picture: localStorage.getItem('userPicture'),
      authMethod: localStorage.getItem('authMethod'),
      userId: localStorage.getItem('userId'),
    };
  }
}

// Export singleton instance
export const ssoService = new SSOService();
export default ssoService;

